import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const AddEditMastiCategoryModal = ({ open, onClose, category, onSuccess }) => {
  const [formData, setFormData] = useState({
    order: "",
    name: "",
    description: "",
    isOfficial: false,
  });
  const [error, setError] = useState("");

  const [loading, setLoading] = useState(false);

  const isEdit = !!category;

  useEffect(() => {
    if (category) {
      setFormData({
        order: category.order || "",
        name: category.name || "",
        description: category.description || "",
        isOfficial: category.isOfficial || false,
      });
    } else {
      setFormData({
        order: "",
        name: "",
        description: "",
        isOfficial: false,
      });
    }
  }, [category]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setError("");

      const payload = {
        ...formData,
      };

      if (isEdit) {
        await axios.put(
          `${BASE_URL}/masti-categories/update/${category._id}`,
          payload
        );
      } else {
        await axios.post(`${BASE_URL}/masti-categories/create`, payload);
      }

      onSuccess();
      onClose();
    } catch (error) {
      setError(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm backdrop-brightness-75">
      <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-xl">
        <div className="mb-5 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-800">
            {isEdit ? "Edit Category" : "Add Category"}
          </h2>

          <button
            type="button"
            onClick={onClose}
            className="text-2xl text-gray-400"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Order Slot
            </label>

            <input
              type="number"
              name="order"
              placeholder="Enter at which place you want to show it in app"
              value={formData.order}
              onChange={handleChange}
              className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-pink-500"
              required
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Category Name
            </label>

            <input
              type="text"
              name="name"
              placeholder="Enter category name"
              value={formData.name}
              onChange={handleChange}
              className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-pink-500"
              required
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              Description
            </label>

            <textarea
              rows={4}
              name="description"
              placeholder="Enter description"
              value={formData.description}
              onChange={handleChange}
              className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-pink-500"
            />
          </div>

          <div className="flex items-center gap-3 rounded-xl border border-gray-200 p-4">
            <input
              id="isOfficial"
              type="checkbox"
              name="isOfficial"
              checked={formData.isOfficial}
              onChange={handleChange}
              className="h-4 w-4 cursor-pointer"
            />

            <label
              htmlFor="isOfficial"
              className="cursor-pointer text-sm font-medium text-gray-700"
            >
              Mark this category as Official
            </label>
          </div>

          {error && (
            <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">
              {error}
            </div>
          )}

          <div className="flex items-center justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="rounded-xl border border-gray-300 px-5 py-2 text-sm font-medium"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="rounded-xl bg-pink-500 px-5 py-2 text-sm font-medium text-white disabled:cursor-not-allowed disabled:opacity-70"
            >
              {loading
                ? "Please wait..."
                : isEdit
                ? "Update Category"
                : "Add Category"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEditMastiCategoryModal;
